// extracted by mini-css-extract-plugin
export default {"mobile":"FQLk2x0B1W0LMSedCrwv-Header-mobile","desktop":"TzGOl0OrmuxDbDxgQjlg-Header-desktop","sticky":"QxDCkNP4qQ4mfYoTfS1w-Header-sticky"};